/**
 * BUG-132 — what the voice report says about a piece with no voice scores.
 *
 * It used to say one thing for every such piece: run `npm run voice:check`. A
 * command is not something an app user can act on, and "no scores and no
 * notes" also covers a piece that simply has not reached the Editor yet (piece
 * 1828, stopped by the Auditor, was told it "finished before the evaluator
 * existed"). The two cases need different answers:
 *
 * - `not_edited` — no corrected draft. The pipeline scores it when the Editor
 *   runs; there is nothing to do.
 * - `unscored`   — edited, but never scored. The report offers Score voice.
 *
 * `null` means the piece has scores or notes, and the report shows those.
 */
export type UnscoredVoiceState = "not_edited" | "unscored" | null;

export function unscoredVoiceState(opts: {
  hasScoresOrNotes: boolean;
  /** Whether a corrected_draft exists — the Voice Evaluator's input. */
  edited: boolean;
}): UnscoredVoiceState {
  if (opts.hasScoresOrNotes) return null;
  return opts.edited ? "unscored" : "not_edited";
}
